import { type ReactNode } from 'react';

import { Box } from '#/components/Box/Box';
import { useMultiStep } from '#/components/Form/MultiStepForm/useMultiStep';
import { LegacyButton } from '#/components/LegacyButton/LegacyButton';
import { H5 } from '#/components/Text/H5';
import { colors } from '#/theme/theme';

import { MultiStepFormBaseHeader } from './MultiStepFormBaseHeader';

export type HeaderProps = {
  steps: {
    title?: string;
    ignoreInNav?: boolean;
  }[];
  submitDraft?: () => Promise<void>;
  errors: string[][];
  trackingTitle?: string;
  title?: string;
  singlePage?: boolean;
  edited: boolean;
  isDraft?: boolean;
  cartDropdownButton?: ReactNode;
};

export function MultiStepFormHeader({
  steps,
  submitDraft,
  errors,
  trackingTitle,
  title,
  singlePage,
  edited,
  isDraft,
  cartDropdownButton,
}: HeaderProps) {
  const { currentStep, navigateToStep } = useMultiStep();

  const getStepQaId = (index: number) => {
    if (index > currentStep) {
      return 'multi-form-header-future-step';
    }
    if (index === currentStep) {
      return 'multi-form-header-current-step';
    }
    return 'multi-form-header-past-step';
  };

  return (
    <MultiStepFormBaseHeader
      submitDraft={submitDraft}
      edited={edited}
      trackingTitle={trackingTitle}
      title={title}
      isDraft={isDraft}
      cartDropdownButton={cartDropdownButton}
    >
      {!singlePage && (
        <Box display="flex">
          {steps.map((step, index) => {
            const hasError = Boolean(errors?.[index]?.length);
            return (
              <Box
                key={step.title}
                width={1 / steps.length}
                height={50}
                color={(() => {
                  if (hasError) return colors.alertRed;
                  if (index === currentStep) return colors.brandBlue;
                  if (index < currentStep) return colors.mediumContentGrey;
                  return colors.elementGrey;
                })()}
                boxShadow={`0 4px ${(() => {
                  if (hasError) return colors.alertRed;
                  if (index === currentStep) return colors.brandBlue;
                  if (index < currentStep) return '#5dc2f1';
                  return colors.selectionGrey;
                })()}`}
                // @ts-expect-error TS(2322): Type 'false | "1px solid #eaeaea"' is not assignab... Remove this comment to see the full error message
                borderLeft={index > 0 && '1px solid #eaeaea'}
              >
                <Box
                  width="100%"
                  height="100%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <LegacyButton
                    onClick={() => navigateToStep(index)}
                    disabled={index >= currentStep}
                    qaId={getStepQaId(index)}
                  >
                    <H5 textAlign="center" m={0} fontSize={[14, 14, 14, 14]}>
                      {index + 1}. {step.title}
                    </H5>
                  </LegacyButton>
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
    </MultiStepFormBaseHeader>
  );
}
